module.exports = __webpack_public_path__ + "img/phone-shadow-medium.f4ffb236.png";